<div *ngIf="showTooltip" [ngClass]="inputPositionStyles[position]" class="input-tooltip">
  <div [ngClass]="figurePositionStyles[position]"></div>
  <div class="input-tooltip-content">{{ message }}</div>
</div>
